module.exports = {"TXTCLI_Please_enter_a_valid_SSN":{"id":"TXTCLI_Please_enter_a_valid_SSN","defaultMessage":"有効な SSN を入力してください"}}